var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasDiscountApplied && _vm.validDeals.length > 0)?_c('div',{staticClass:"py-4"},[_c('CartProductSlider',_vm._b({},'CartProductSlider',{
      lineItems: _vm.lineItems,
      deals: _vm.validDeals,
    },false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }